import { useMutation } from 'react-query'

import { updateZervantSettings } from '../query-api'

export const useUpdateZervantSettings = () => {
  const { mutate: update, isLoading: isProcessing, ...rest } = useMutation(updateZervantSettings)

  return { update, isProcessing, ...rest }
}
